import { render } from "./DataSourceLegend.vue?vue&type=template&id=62f27b64&scoped=true&ts=true"
import script from "./DataSourceLegend.vue?vue&type=script&lang=ts"
export * from "./DataSourceLegend.vue?vue&type=script&lang=ts"

import "./DataSourceLegend.vue?vue&type=style&index=0&id=62f27b64&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f27b64"]])

export default __exports__